import { render } from "./saved-package-cards.vue?vue&type=template&id=9c7b1e8a&scoped=true&ts=true"
import script from "./saved-package-cards.vue?vue&type=script&lang=ts"
export * from "./saved-package-cards.vue?vue&type=script&lang=ts"

import "./saved-package-cards.vue?vue&type=style&index=0&id=9c7b1e8a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7b1e8a"]])

export default __exports__